import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {QueryUsersForBusinessArgs as QueryArgs} from "@irati/types"
import fullUser from "../fragments/fullUserV4"

export interface QueryUsersArgs extends QueryArgs {
  includeBusiness?: boolean
}

const query = gql`
  query UsersForBusiness(
    $businessId: ID!
    $adminsOnly: Boolean
    $managersOnly: Boolean
    $cursor: String
    $enabled: Boolean
    $activated: Boolean
    $includeBusiness: Boolean!
    $lastNameCharacter: String
    $totalOnly: Boolean
    $offset: Int
    $role: String
    $searchString: String
    $sort: String
    $teamId: ID
    $teamIds: [ID]
    $includeIntegrations: Boolean!
    $userIds: [ID!]
    $hasEmploymentStartDate: Boolean
    $hasDateOfBirth: Boolean
    $excludeRemovedUsers: Boolean
    $includeTeams: Boolean!
    $invitedBy: ID
    $friendsFamilyOnly: Boolean
    $roleIds: [ID]
    $notInRoleIds: [ID]
  ) {
    usersForBusiness(
      businessId: $businessId
      adminsOnly: $adminsOnly
      managersOnly: $managersOnly
      cursor: $cursor
      enabled: $enabled
      activated: $activated
      lastNameCharacter: $lastNameCharacter
      totalOnly: $totalOnly
      offset: $offset
      role: $role
      searchString: $searchString
      sort: $sort
      teamId: $teamId
      teamIds: $teamIds
      userIds: $userIds
      hasEmploymentStartDate: $hasEmploymentStartDate
      hasDateOfBirth: $hasDateOfBirth
      excludeRemovedUsers: $excludeRemovedUsers
      invitedBy: $invitedBy
      friendsFamilyOnly: $friendsFamilyOnly
      roleIds: $roleIds
      notInRoleIds: $notInRoleIds
    ) {
      total
      cursor
      results {
        ...fullUser
        teams @include(if: $includeTeams) {
          results {
            uuid
            teamState
            teamName
          }
        }
        ssoId @include(if: $includeIntegrations)
        directorySyncId @include(if: $includeIntegrations)
        business @include(if: $includeBusiness) {
          uuid
          businessName
        }
      }
    }
  }
  ${fullUser}
`

export const usersForBusinessKey = getQueryNames(query)[0]

export default query
